import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PlanMenu from "./PlanMenu";
import HelpLinks from "./HelpLinks";

/**
 * The strip above the steps: the plan on the left, help on the right, and the
 * way out. Below `md` the help links shrink to their icons — at 360px the plan
 * button, three labelled links and a close button do not fit on one line.
 * `videoUrl` is the current step's video.
 */
const WizardTopBar = ({ plan, quotes, onPlanSelect, planBusy, onClose, videoUrl }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-2 border-b border-ink-200 px-3 py-2 sm:px-6">
      <PlanMenu
        plan={plan}
        quotes={quotes}
        onSelect={onPlanSelect}
        busy={planBusy}
      />

      <div className="flex shrink-0 items-center gap-0.5 sm:gap-1">
        <HelpLinks videoUrl={videoUrl} />
        <button
          type="button"
          onClick={onClose}
          aria-label={t("Dashboard.Setup.close")}
          className="ml-1 inline-flex size-11 cursor-pointer items-center justify-center rounded-lg text-ink-500 transition hover:bg-ink-100 hover:text-ink-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
        >
          <i className="bi bi-x-lg text-lg" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

WizardTopBar.propTypes = {
  plan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  quotes: PropTypes.object.isRequired,
  onPlanSelect: PropTypes.func.isRequired,
  planBusy: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  videoUrl: PropTypes.string,
};

export default WizardTopBar;
